import React, {useContext} from "react";
import {LinesContext, WindowContext} from '@web/hooks/context';
import DataTable from '@web/components/DataTable';
import CollectionFetch from '@web/ui/containers/CollectionFetch';
import {useSelector} from 'react-redux';
import Loading from '@web/components/Loading';

function CollectionManager() {
  const [isMobile] = useContext(WindowContext);
  const ctx = React.useContext(LinesContext);
  const collection = useSelector((state) => {
    return state.Collections?.data?.[ctx.basePath + "/collections/" + ctx.collectionId];
  });

  if (!collection) {
    return <Loading />;
  }

  return <div className="w-full relative">
    <div className="services-tabs-header" style={{backgroundColor: isMobile ? "rgba(0,0,0,0.75)" : ""}}>
    </div>
    <CollectionFetch
      collectionId={ctx.collectionId}
      component={DataTable}
    />
  </div>
}

export default CollectionManager;
